import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UvjerenjaService } from './uvjerenja.service';
import * as toastr from 'toastr';
import { Uvjerenje } from './uvjerenja';
import { Subject } from 'rxjs';
import { AppConfig } from '../../../config';
import * as alertify from 'alertify.js';

@Component({
  selector: 'app-uvjerenja',
  templateUrl: './uvjerenja.component.html',
  styleUrls: ['./uvjerenja.component.css'],
  providers: [UvjerenjaService]
})
export class UvjerenjaComponent implements OnInit {

  svaUvjerenja: Uvjerenje[] = [];
  uvjerenjaOptions: DataTables.Settings = {};
  uvjerenjaTrigger: Subject<Uvjerenje> = new Subject();
  uvjerenjeForma: FormGroup;
  uvjerenjeEditForma: FormGroup;
  filee:any;
  svapodrucjaznanja: any = [];
  dokumentId: string;
  accessToken: any = localStorage.getItem('tokenSql');
  URL: any = AppConfig.IPfile;

  constructor(
    private _fb: FormBuilder,
    private _uvjerenjaService: UvjerenjaService
  ) {}

  ngOnInit() {
    this.dohvati();
    this.dohvatiPodrucjaznanja();
    //Tablica početak
    this.uvjerenjaOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
          targets: 'no-sort',
          orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj

    this.uvjerenjeForma = this._fb.group({
      naziv: [''],
      vrstaEdukacije: [''],
      podrucjeZnanja: [''],
      file: ['']
    });

    this.uvjerenjeEditForma = this._fb.group({
      id: [''],
      naziv: [''],
      podrucjeZnanja: ['']
    });
  }

  dohvatiPodrucjaznanja(){
    this._uvjerenjaService.dohvatiSvaPodrucjaznanja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
        this.svapodrucjaznanja = res.data;
      } else {
        this.svapodrucjaznanja = [];
      }
    })
  }

  pripremiPodatke(dokument){
    //console.log(dokument);
    this.dokumentId = dokument['id'];
    this.uvjerenjeEditForma = this._fb.group({
      naziv: dokument['naziv'],
      podrucjeZnanja: dokument['idpodrucjeznanja']
    });
  }

  uredi(dokument){
    //console.log(dokument);
    let podaciZaSlanje = {
      'iduploaddokument': this.dokumentId,
      'naziv': dokument['naziv'],
      'idpodrucjeznanja': dokument['podrucjeZnanja'],
      'access_token': localStorage.getItem('tokenSql')
    }
    //console.log(podaciZaSlanje);
    this._uvjerenjaService.urediDokument(podaciZaSlanje).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        this.dohvati();
      } else {
        toastr.error("Neuspješno uređivanje!");
      }
    });
  }

  fileChange(event){
    //console.log(event)
    this.filee = event.target.files;
    //console.log(this.filee);
  }
  
  spremi(uvjerenjeForma){
    //console.log(uvjerenjeForma);
    if(uvjerenjeForma['naziv'] && uvjerenjeForma['vrstaEdukacije'] && uvjerenjeForma['podrucjeZnanja'] && uvjerenjeForma['file']){
      let formData:FormData = new FormData();
      formData.append('naziv', uvjerenjeForma.naziv);
      formData.append('datoteka', this.filee[0], this.filee[0].name);
      formData.append('idpodrucjeznanja', uvjerenjeForma['podrucjeZnanja']);
      formData.append('nazivtablice', uvjerenjeForma['vrstaEdukacije']);
      //console.log(formData);
      this._uvjerenjaService.dodajDokument(formData).subscribe(res => {
        if(res.success == true){
          toastr.success("Uspješno dodano uvjerenje!");
          this.dohvati();
          this.uvjerenjeForma = this._fb.group({
            naziv: [''],
            vrstaEdukacije: [''],
            podrucjeZnanja: [''],
            file: ['']
          });
        } else {
          toastr.error("Neuspješno spremanje!");
        }
      });
    } else {
      toastr.error("Unesite potrebne podatke!");
    }
  }

  dohvati(){
    this.svaUvjerenja = [];
    this._uvjerenjaService.dohvatiUvjerenja({'idkorisnik': localStorage.getItem('userId')}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          this.svaUvjerenja.push({
            'id': res.data[i]['iduploaddokument'],
            'naziv': res.data[i]['ud_naziv'],
            'vrstaedukacije': res.data[i]['vrsta_edukacije'],
            'idpodrucjeznanja': res.data[i]['idpodrucjeznanja'],
            'podrucjeznanja': res.data[i]['pu_naziv'],
            'ud_nazivtablice': res.data[i]['ud_nazivtablice'],
            'ud_nazivdokumenta': res.data[i]['ud_nazivdokumenta']
          });
        }
        this.uvjerenjaTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    });
  }

  obrisiDokument(dokument){
    //console.log(dokument);
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite obrisati dokument?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._uvjerenjaService.obrisiDokument({'iduploaddokument': dokument.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Dokument uspješno obrisan!");
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja dokumenta.');
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/uvjerenja/uvjerenja.component.ts